import { Injectable } from '@angular/core';
export class LibService {
constructor() { }
/**
 * @return {?}
 */
getMeaning() { return 42; }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function LibService_tsickle_Closure_declarations() {
/** @type {?} */
LibService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
LibService.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
